import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AppService } from '../app-service/app-service.service';
import { SnackBarService } from '../snack-bar/snack-bar.service';
import { AppTranslateService } from '../translate/translate.service';
import { APIServices } from '../../../config/app-config';
import { Router } from '@angular/router';
import { Observable, AsyncSubject, of } from 'rxjs';
import { map, tap, delay } from 'rxjs/operators';

@Injectable()
export class WinAuthInterceptor implements HttpInterceptor {
    constructor(private appService: AppService,
    private snackBar: SnackBarService,
    private translate: AppTranslateService,
    private router: Router) {}

  public cache: { [name: string]: CacheRequest } = {};

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userInfo = this.appService.getFromLocal(environment.userStorage);
    const token = this.appService.getFromLocal(environment.jwt);
    if (req.urlWithParams != APIServices.admin.login.GetToken) {
      req = req.clone({
        withCredentials: true,
        headers: req.headers.set('Authorization', 'Bearer ' + token)
      });
    } else {
      req = req.clone({
        withCredentials: true
      });
    }

    if (req.method !== 'GET' || req.urlWithParams.includes('/assets/i18n/') || req.params.get('Cache-control') == null) {

        return next.handle(req)
        .pipe(
          map(event => {
            if (event instanceof HttpResponse) {
              if (event.body != null && event.body.Errors != null && event.body.Errors.length > 0) {
                event.body.Errors.forEach(message => {
                  this.snackBar.openSnackBarError('Error: ' + message, this.translate.translateText('General.Btn.Close'));
                });
                throw new Error('Error controlado por la aplicación y por el cual se muestra un mensaje de información ' + event.status);
              }
              return event;
            }
          }, error => {
            this.snackBar.openSnackBarError('Error: ' + error.error, this.translate.translateText('General.Btn.Close'));
          })
        );

    } else if (this.cache[req.urlWithParams] && this.cache[req.urlWithParams].expirationDate < new Date()) {
      this.cache[req.urlWithParams] = null;
    }

    const cachedResponse = this.cache[req.urlWithParams] || null;
    if (cachedResponse) {
      return cachedResponse.request.pipe(delay(0));
    }

    let subject = (this.cache[req.urlWithParams] = new CacheRequest(Number(req.params.get('Cache-control'))));

    next.handle(req)
    .pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          subject.request.next(event);
          subject.request.complete();
        }
      })
    )
    .subscribe(); // must subscribe to actually kick off request!

    return subject.request;
  }

  private handleError(err: HttpErrorResponse, _self): Observable<any> {
    console.log(err);
    if (err.status === 401 || err.status === 403) {
      sessionStorage.removeItem(environment.userStorage);
      _self.appService.iconBreadCrumb = undefined;
      _self.appService.existMenu = false;
      _self.appService.checkLogged();
// tslint:disable-next-line: max-line-length
      if (_self.appService.actualUrl && _self.appService.actualUrl != '/login' && _self.appService.actualUrl != '/login/login') {
        _self.router.navigate(['']);
      }
      return of(err.message);
    }
    // handle your auth error or rethrow
    return Observable.throw(err);
  }
}

class CacheRequest {
  public expirationDate: Date;
  public request: AsyncSubject<HttpEvent<any>>;

  constructor(expirationSeconds: number) {
    this.request = new AsyncSubject<HttpEvent<any>>();
    let date = new Date();
    date.setSeconds(date.getSeconds() + expirationSeconds);
    this.expirationDate = date;
  }
}
